module.exports = __webpack_public_path__ + "img/idea-leader.68da4fe0.svg";